import type {MenuItemConfig} from '@myparcel-frontend/ui';
import {Subscription} from '@myparcel-frontend/icons/legacy';
import {markRaw} from 'vue';

export const getSubscriptionsMenu = (): MenuItemConfig => {
  return {
    type: 'internal',
    to: {
      name: 'subscription-overview',
    },
    activeRouteNameAliases: [
      'subscriptions-bundles',
      'subscriptions-my-contracts',
      'subscriptions-my-analytics',
      'subscriptions-my-orders',
      'subscriptions-my-scan-and-print',
      'subscriptions-my-returns',
    ],
    label: 'subscriptions.title',
    multiplyLabel: true,
    icon: markRaw(Subscription),
  };
};
